import { supabase } from "@/integrations/supabase/client";
import { useCallback } from "react";
import { trackEvent } from "@/lib/trackEvent";

export function useAffiliateTracking() {
  const trackAffiliateClick = useCallback(async (
    platform: 'coinspot' | 'swyftx' | 'independent_reserve' | 'coinjar' | 'binance',
    articleId?: string
  ) => {
    try {
      // Log to console for debugging
      console.log('Affiliate click:', { platform, articleId, timestamp: new Date().toISOString() });

      // Forward to Command Centre (fire-and-forget)
      trackEvent('conversion', { type: 'affiliate_click', exchange: platform });

      // Track in localStorage for analytics
      const clicks = JSON.parse(localStorage.getItem('affiliate_clicks') || '[]');
      clicks.push({
        platform,
        articleId,
        timestamp: new Date().toISOString()
      });
      localStorage.setItem('affiliate_clicks', JSON.stringify(clicks));

      // Update post analytics in Supabase if we have an article ID
      if (articleId) {
        // Get current analytics
        const { data: analytics } = await supabase
          .from('post_analytics')
          .select('*')
          .eq('blog_post_id', articleId)
          .eq('date', new Date().toISOString().split('T')[0])
          .single();

        if (analytics) {
          // Increment the specific platform click count
          const currentClicks = analytics.affiliate_clicks as any || {};
          const updatedClicks = {
            ...currentClicks,
            [platform]: (currentClicks[platform] || 0) + 1
          };

          await supabase
            .from('post_analytics')
            .update({ affiliate_clicks: updatedClicks })
            .eq('id', analytics.id);
        } else {
          // Create new analytics record
          await supabase
            .from('post_analytics')
            .insert({
              blog_post_id: articleId,
              date: new Date().toISOString().split('T')[0],
              affiliate_clicks: { [platform]: 1 }
            });
        }
      }

      // Google Analytics tracking (if gtag is available)
      if (typeof window !== 'undefined' && (window as any).gtag) {
        (window as any).gtag('event', 'affiliate_click', {
          platform: platform,
          article_id: articleId,
          timestamp: Date.now()
        });
      }
    } catch (error) {
      console.error('Error tracking affiliate click:', error);
    }
  }, []);

  return { trackAffiliateClick };
}
